import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { authApi } from '@/api/auth';
import { useAuthStore } from '@/store/authStore';
import './LoginPage.css';

export default function LoginPage() {
  const navigate = useNavigate();
  const setAuth = useAuthStore((s) => s.setAuth);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (loading) return;
    setError(null);
    setLoading(true);
    try {
      const resp = await authApi.login(username.trim(), password);
      setAuth(resp.token, resp.user);
      navigate('/editor', { replace: true });
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const msg = (err.response?.data as { message?: string } | undefined)?.message;
        setError(msg ?? 'Falha ao conectar com a central de autenticação.');
      } else {
        setError('Erro inesperado ao autenticar.');
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={onSubmit}>
        <div className="login-brand">
          SQL-M8<span className="login-brand-sub">/console</span>
        </div>
        <p className="login-subtitle">Acesse com sua conta da central de aplicações M8</p>

        <label className="login-label">USUÁRIO</label>
        <input
          className="login-input"
          type="text"
          autoFocus
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="seu.usuario"
        />

        <label className="login-label">SENHA</label>
        <div className="login-pwd-wrap">
          <input
            className="login-input"
            type={showPwd ? 'text' : 'password'}
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
          />
          <button
            type="button"
            className="login-pwd-toggle"
            onClick={() => setShowPwd((v) => !v)}
            tabIndex={-1}
          >
            {showPwd ? 'ocultar' : 'mostrar'}
          </button>
        </div>

        {error && <div className="login-error">✕ {error}</div>}

        <button className="login-submit" type="submit" disabled={loading || !username || !password}>
          {loading ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
